module.exports = __webpack_public_path__ + "static/img/11.88e1a2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/sp/11.png
// module id = yTMH
// module chunks = 0